import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import "../../style/captcha.css";
import async from "../../utils/service.js";
import { Dialog } from "primereact/dialog";
import logo from "../../assets/cargillLogo.png";
import miLogo from "../../assets/Logo1.png";
import { MultiSelect } from "primereact/multiselect";
import { ScrollPanel } from "primereact/scrollpanel";
import ReCAPTCHA from "react-google-recaptcha";
import { environment } from "../../env";
import { Toast } from "primereact/toast";
import { validateForPersonalEmail } from "../../utils/email-validation.js";

const disclaimer =
  "Legal Disclaimer MiApp is offered by Cargill, Incorporated. The information within MiApp does not constitute:  investment service, investment advice, or financial product advice as defined by laws and/or regulations in any jurisdiction, and the contents should not be construed as investment, legal or tax advice. Each person should seek independent investment, legal and tax advice concerning the consequence of entering into any pricing decision. The information and materials contained in MiApp are subject to change without notice. Cargill does not guarantee the results or outcome of any action or inaction based on such information. Recipients of MiApp should conduct their own analysis, using such assumptions as they deem appropriate, and should fully consider other available information in making a decision";

const title = "Cargill MiApp Login Credentials Request Form";

function UserRegistration() {
  const reCaptchaRef = React.useRef(null);

  const [success, setSuccess] = React.useState(0);
  const [error, setError] = React.useState(true);
  const [apiError, setApiError] = React.useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialUserState = {
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    country: undefined,
    city: "",
    managerEmail: "",
    checked: false,
    captchaSuccess: false,
  };
  const [user, setUser] = React.useState(initialUserState);
  const [otherCountry, setOtherCountry] = React.useState("");
  const [countryList, setCountryList] = React.useState([]);
  const [regionList, setRegionList] = React.useState([]);
  const [regions, setRegions] = React.useState([{}]);
  const [channels, setChannels] = React.useState([]);
  const [channelId, setChannelId] = React.useState(0);
  const [ChanRegmapping, setChanRegMapping] = React.useState({});
  const cargillEmailToastRef = useRef(null);
  const invalidEmailToastRef = useRef(null);
  const [isCargillEmail, setIsCargillEmail] = useState(false);
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);

  function handleOnInvalid(e) {
    let ele = e.target;
    if (ele.validity.patternMismatch) {
      ele.setCustomValidity(
        "Please enter a valid email address. Allowed characters Alphanumeric-_.@ followed by Alphanumeric-"
      );
    } else {
      ele.setCustomValidity("");
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (isCargillEmail) {
      showCargillWarning();
      return;
    }
    if (isInvalidEmail) {
      showInvalidEmailWarning();
      return;
    }
    let isRegionEmpty =
      (isSubmitting && !user.region) || (isSubmitting && Array.isArray(user.region) && user.region.length === 0);
    let reCatchaResponse = reCaptchaRef.current.getValue();

    if (reCatchaResponse.trim() !== "") {
      if (isRegionEmpty) return;
      setError(true);
      let dataToSend = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        companyName: user.companyName,
        city: user.city,
        managerEmail: user.managerEmail,
        captchaToken: reCatchaResponse,
      };
      var channeldto = {
        channelId: channelId,
        regionRequestDTOS: [],
      };
      user.region.map((reg) => channeldto["regionRequestDTOS"].push({ regionId: reg }));
      if (user.country.countryName === "Other") {
        dataToSend["country"] = otherCountry;
      } else {
        dataToSend["countryId"] = user.country.countryId;
      }
      dataToSend["channelRequestDTO"] = channeldto;
      async
        .createUser(dataToSend)
        .then((response) => {
          setUser(initialUserState);
          setRegions([{}]);
          setOtherCountry("");
          setSuccess(1);
          reCaptchaRef.current.reset();
        })
        .catch((err) => {
          setApiError(err.response.data);
          setUser(initialUserState);
          setRegions([{}]);
          setOtherCountry("");
          setSuccess(2);
          reCaptchaRef.current.reset();
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    } else {
      setError(false);
    }
  }

  function showCargillWarning() {
    cargillEmailToastRef.current.show({
      severity: "error",
      summary: "Error",
      detail:
        "As a Cargill employee you already have access to this application. Please download the app on your phone to start using.",
      life: 6000,
    });
  }

  function showInvalidEmailWarning() {
    invalidEmailToastRef.current.show({
      severity: "error",
      summary: "Error",
      detail: "Only company email address allowed",
      life: 6000,
    });
  }

  function handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    if (name === "channel") {
      setChannelId(value);
      setRegions(regionList[parseInt(ChanRegmapping[parseInt(value)])]);
    }
    if (name === "email") {
      const lowerCaseEmail = value.toLowerCase();
      setIsCargillEmail(lowerCaseEmail.includes("cargill.com") || lowerCaseEmail.includes("crgl-thirdparty.com"));
      setIsInvalidEmail(validateForPersonalEmail(lowerCaseEmail));
    }
    setUser({ ...user, [name]: value });
  }

  useEffect(() => {
    if (isCargillEmail) {
      showCargillWarning();
    }
  }, [isCargillEmail]);

  useEffect(() => {
    if (isInvalidEmail) {
      showInvalidEmailWarning();
    }
  }, [isInvalidEmail]);

  React.useEffect(() => {
    async.getRegionCountry().then((response) => {
      response.data.countries.push({ countryName: "Other" });
      setCountryList(response.data.countries);
      setChannels(
        response.data.availableChannels.map((item) => {
          var res = {};
          Object.assign(res, item);
          delete res["regions"];
          return res;
        })
      );
      setRegionList(response.data.availableChannels.map((item) => item.regions));
      const temp_channels = response.data.availableChannels;
      var temp_mapping = {};
      for (var i = 0; i < temp_channels.length; i++) {
        temp_mapping[temp_channels[i].channelId] = i;
      }
      setChanRegMapping(temp_mapping);
    });
  }, []);

  const isRegionInValid =
    (isSubmitting && !user.region) || (isSubmitting && Array.isArray(user.region) && user.region.length === 0);
  const isChannelInValid = isSubmitting && !user.channel;
  const isCountryInValid = isSubmitting && !user.country;

  return (
    <div className='main-box'>
      <div className='grid'>
        <div className='lg:col-5 col-12'>
          <div className='banner flex align-items-center justify-content-center'>
            <img src={miLogo} className='logo1' alt='mi-logo' />
          </div>
        </div>

        <div className='lg:col-7 col-12'>
          <ScrollPanel style={{ height: "100vh" }}>
            <img src={logo} className='logo' alt='cargill-logo' />
            <h2 className='title'>{title}</h2>
            <form className='main' onSubmit={(e) => handleSubmit(e)}>
              <div className='p-fluid formgrid grid mt-6'>
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label htmlFor='firstname' className='label'>
                    * First Name
                  </label>
                  <InputText
                    name='firstName'
                    type='text'
                    value={user.firstName}
                    onChange={handleChange}
                    required
                    maxLength={100}
                    keyfilter={/^[a-zA-Z0-9 ]+/}
                  />
                </div>
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label htmlFor='lastname' className='label'>
                    * Last Name
                  </label>
                  <InputText
                    name='lastName'
                    type='text'
                    value={user.lastName}
                    onChange={handleChange}
                    required
                    maxLength={100}
                    keyfilter={/^[a-zA-Z0-9 ]+/gm}
                  />
                </div>
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label htmlFor='emailId' className='label'>
                    * Company Email Address
                  </label>
                  <InputText
                    name='email'
                    type='text'
                    value={user.email}
                    onChange={handleChange}
                    required={user?.email?.length > 0 && !isCargillEmail}
                    maxLength={200}
                    keyfilter='email'
                    pattern='[a-zA-Z0-9\-_.]+@([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}$'
                    onInvalid={handleOnInvalid}
                  />
                </div>
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label htmlFor='companyName' className='label'>
                    * Company Name
                  </label>
                  <InputText
                    name='companyName'
                    type='text'
                    value={user.companyName}
                    onChange={handleChange}
                    required
                    maxLength={250}
                    keyfilter={/^[a-zA-Z0-9 ]+/}
                  />
                </div>
                <div
                  className={
                    user?.country?.countryName === "Other"
                      ? "field col-12 md:col-3 sm:col-6"
                      : "field col-12 md:col-6 sm:col-6"
                  }
                >
                  <label htmlFor='country' className={`label ${isCountryInValid ? "error" : ""}`}>
                    * Office Location — COUNTRY
                  </label>
                  <Dropdown
                    name='country'
                    optionLabel='countryName'
                    value={user?.country}
                    options={countryList}
                    onChange={handleChange}
                    required
                    filter
                    resetFilterOnHide
                    pt={{
                      header: { style: { backgroundColor: "#252525" } },
                    }}
                    className={`${isCountryInValid ? "p-invalid" : ""}`}
                  />
                  {isCountryInValid && <div className='error text-left'>Country is required</div>}
                </div>
                {user?.country?.countryName === "Other" ? (
                  <div className='field col-12 md:col-3 sm:col-6'>
                    <label className='label'>* Country Name (spell out)</label>
                    <InputText
                      name='other_country'
                      value={otherCountry}
                      type='text'
                      onChange={(e) => setOtherCountry(e.target.value)}
                      required
                      maxLength={100}
                      keyfilter={/^[a-zA-Z0-9() ]+/}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label className='label'>* Office Location — CITY (spell out)</label>
                  <InputText
                    name='city'
                    value={user.city}
                    type='text'
                    onChange={handleChange}
                    required
                    maxLength={100}
                    keyfilter={/^[a-zA-Z0-9 ]+/}
                  />
                </div>

                <div className='divider col-10 col-offset-1' />
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label className={`label ${isChannelInValid ? "error" : ""}`}>* Channel</label>
                  <Dropdown
                    name='channel'
                    value={user.channel}
                    options={channels}
                    optionLabel='channelName'
                    optionValue='channelId'
                    onChange={handleChange}
                    required
                    filter
                    resetFilterOnHide
                    pt={{
                      header: { style: { backgroundColor: "#252525" } },
                    }}
                    className={`${isChannelInValid ? "p-invalid" : ""}`}
                  />
                  {isChannelInValid && <div className='error text-left'>Channel is required</div>}
                </div>
                <div className='field col-12 md:col-6 sm:col-12'>
                  <label htmlFor='zip' className={`label ${isRegionInValid ? "error" : ""}`}>
                    * Region
                  </label>
                  <MultiSelect
                    value={user.region}
                    options={regions}
                    optionLabel='region'
                    optionValue='regionId'
                    tooltip={JSON.stringify(regions) === JSON.stringify([{}]) ? "Please select channel" : null}
                    tooltipOptions={{ position: "bottom" }}
                    onChange={(e) => setUser({ ...user, region: e.value })}
                    selectedItemsLabel='{0} regions selected'
                    className={`${isRegionInValid ? "p-invalid" : ""}`}
                  />
                  {isRegionInValid && <div className='error text-left'>Region is required</div>}
                </div>
                <div className='field col-12 md:col-12 sm:col-12'>
                  <label htmlFor='zip' className='label'>
                    * Cargill Account Manager Email Address (if you are a Cargill employee, please enter your Cargill
                    email address)
                  </label>
                  <InputText
                    name='managerEmail'
                    type='text'
                    value={user.managerEmail}
                    onChange={handleChange}
                    required
                    maxLength={200}
                    keyfilter='email'
                    pattern='[a-zA-Z0-9\-_.]+@([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}$'
                    onInvalid={handleOnInvalid}
                  />
                </div>
                <div className='field col-12 md:col-12 sm:col-12 flex align-items-center justify-content-center'>
                  <ReCAPTCHA
                    ref={reCaptchaRef}
                    sitekey={environment.google_recaptch_sitekey}
                    theme='dark'
                    onChange={(val) => {
                      if (val !== null) {
                        setError(true);
                      }
                    }}
                    onError={() => {
                      reCaptchaRef.current.reset();
                    }}
                  />
                  {!error ? <div className='error'>Please fill the Captcha</div> : ""}
                </div>
                <div className='field-checkbox sm:col-12'>
                  <Checkbox
                    onChange={(e) => setUser({ ...user, checked: e.checked })}
                    checked={user.checked}
                    required
                  />
                  <label className='label' htmlFor='city1'>
                    {disclaimer}
                  </label>
                </div>
                <div className='field block mx-auto '>
                  <Button
                    type='submit'
                    label='Submit'
                    className='p-button-raised btn2 '
                    onClick={() => setIsSubmitting(true)}
                    disabled={isCargillEmail || isInvalidEmail}
                  />
                </div>
              </div>
            </form>
          </ScrollPanel>
        </div>
      </div>
      <Dialog
        baseZIndex={10001}
        className={success === 2 ? "user_diag_red" : "user_diag_green"}
        header={success === 1 ? "Registration Successful !!!" : "Registration Error"}
        visible={success === 1 || success === 2}
        style={{ width: "50vw" }}
        onHide={() => {
          setApiError("");
          setSuccess(0);
        }}
        focusOnShow={false}
      >
        <div>
          {success === 1 ? (
            <p>
              Thank you for requesting access to obtain your personal MiApp Login Credentials. We will shortly send an
              email confirmation on the access.
            </p>
          ) : (
            <p>{apiError}</p>
          )}
          <Button
            className='mi-btn w-100'
            label='Okay'
            onClick={() => {
              setApiError("");
              setSuccess(0);
            }}
          />
        </div>
      </Dialog>
      <Toast ref={cargillEmailToastRef} position='top-center' />
      <Toast ref={invalidEmailToastRef} position='top-center' />
    </div>
  );
}

export default UserRegistration;
